import React from "react";
import { default as BaseSvg } from "react-inlinesvg";

const Svg = ({ active, className, icon, strokeClass }) => {
  const stroke = active ? "[&>path]:stroke-theme-accent" : "[&>path]:stroke-theme-text";

  return (
    <i className={className ?? ""}>
      <BaseSvg className={`transition-all ${strokeClass ?? stroke}`} src={icon} />
    </i>
  );
};

export default Svg;
